export const infoRequired = {
    required: true,
    message: 'Essa informação é obrigatória'
}

export const validateName = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        if (String(value).length >= 5) {
            callback()
        } else {
            callback('Esse campo deve conter pelo menos 5 caracteres')
        }
    }
})

export const validateCpf = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        const cpf = String(value).replace(/\D/g, "").trim()
        let isValid = !!cpf
        let isSame = true
    
        for (const c of cpf) {
          if (!isSame) {
            break
          }
          isSame = c === cpf[0]
        }
    
        if (!isSame) {
            for (let i = 0; i < 2 && isValid; i++) {
                const cpfRange = 9 + i
                const soma = cpf
                    .substr(0, cpfRange)
                    .split("")
                    .reduce((acc, value, index) => {
                        const multiplier = cpfRange - index + 1
                        return acc + Number(value) * multiplier
                    }, 0);
                const digitValidator = Number(cpf.substring(cpfRange, cpfRange + 1))
                const modulo = (soma * 10) % 11
                isValid = ([10, 11].includes(modulo) ? 0 : modulo) === digitValidator
            }
        }
        
        if (isValid && !isSame) {
            callback()
        } else {
            callback('Insira um número de CPF válido')
        }
    }
})

export const validateCpfCnpj = () => ({
    validator: (_, value, callback) => {
        if(value.length === 14) {
            if (!value) return callback()
            const cpf = String(value).replace(/\D/g, "").trim()
            let isValid = !!cpf
            let isSame = true
        
            for (const c of cpf) {
            if (!isSame) {
                break
            }
            isSame = c === cpf[0]
            }
        
            if (!isSame) {
                for (let i = 0; i < 2 && isValid; i++) {
                    const cpfRange = 9 + i
                    const soma = cpf
                        .substr(0, cpfRange)
                        .split("")
                        .reduce((acc, value, index) => {
                            const multiplier = cpfRange - index + 1
                            return acc + Number(value) * multiplier
                        }, 0);
                    const digitValidator = Number(cpf.substring(cpfRange, cpfRange + 1))
                    const modulo = (soma * 10) % 11
                    isValid = ([10, 11].includes(modulo) ? 0 : modulo) === digitValidator
                }
            }
            
            if (isValid && !isSame) {
                callback()
            } else {
                callback('Insira um número de CPF válido')
            }
        } else {
            let cnpj = value.replace(/[^\d]+/g,'');
    
            if(cnpj === '') return false;

            if(cnpj.length < 11) {
                callback('Insira um documento válido')
            }
            
            if (cnpj.length > 11 && cnpj.length < 14)
                callback('Insira um número de CNPJ válido')
        
            // Elimina CNPJs invalidos conhecidos
            if (cnpj === "00000000000000" || 
                cnpj === "11111111111111" || 
                cnpj === "22222222222222" || 
                cnpj === "33333333333333" || 
                cnpj === "44444444444444" || 
                cnpj === "55555555555555" || 
                cnpj === "66666666666666" || 
                cnpj === "77777777777777" || 
                cnpj === "88888888888888" || 
                cnpj === "99999999999999")
                callback('Insira um número de CNPJ válido')
                
            // Valida DVs
            let tamanho = cnpj.length - 2
            let numeros = cnpj.substring(0,tamanho);
            let digitos = cnpj.substring(tamanho);
            let soma = 0;
            let pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                    pos = 9;
            }
            let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) {
                callback('Insira um número de CNPJ válido')
            }
                
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                callback('Insira um número de CNPJ válido')
                
            callback()
        }
    }
})

export const validateCnpj = () => ({
    validator: (_, value, callback) => {
        let cnpj = value.replace(/[^\d]+/g,'');
    
        if(cnpj === '') return false;
        
        if (cnpj.length !== 14)
            callback('Insira um número de CNPJ válido')
    
        // Elimina CNPJs invalidos conhecidos
        if (cnpj === "00000000000000" || 
            cnpj === "11111111111111" || 
            cnpj === "22222222222222" || 
            cnpj === "33333333333333" || 
            cnpj === "44444444444444" || 
            cnpj === "55555555555555" || 
            cnpj === "66666666666666" || 
            cnpj === "77777777777777" || 
            cnpj === "88888888888888" || 
            cnpj === "99999999999999")
            callback('Insira um número de CNPJ válido')
            
        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0,tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== digitos.charAt(0))
            callback('Insira um número de CNPJ válido')
            
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== digitos.charAt(1))
            callback('Insira um número de CNPJ válido')
            
        callback()
    }
})

export const validateTelefone = () => ({
    validator: (_, value, callback) => {
        if (!value || [10, 11].includes( String(value).replace(/\D/g, '').length )) {
            callback()
        } else {
            callback('Insira um número de telefone válido')
        }
    }
})

export const validateEmail = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        // eslint-disable-next-line no-control-regex
        const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        if (emailRegex.test(value)) {
            callback()
        } else {
            callback('Insira um endereço de e-mail válido')
        }
    }
})

export const validatePassword =  () => ({
    validator: async (_, value, callback) => {
        if (!value) return callback()        
           if (String(value).match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*.&@#"'\+^~\`\´\[\]\{\}\(\)\\|/_=<>;:,?!%-])[0-9a-zA-Z$*.&@#"'\+^~\`\´\[\]\{\}\(\)\\|/_=<>;:,?!%-]{8,30}$/)) {
            if(await validateAlphabetic(value)){
                if(await validateNumeric(value)) {
                    callback()
                } else {
                    callback('Não são permitidas sequências numéricas')
                }
            } else {
                callback('Não são permitidas sequências alfabéticas')
            }
        } else {
            callback('A senha deve conter pelo menos 8 caracteres, letras maiúsculas, minúsculas e um caractere especial.')
        }
    }
})

export const validateNumeric = (value) => {
    var pattern = '0123456789012345789' //to match circular sequence as well.
    var regexStr = value.match(/[a-z]+|[^a-z]+/gi);
    for(var i = 0; i < regexStr.length; i++) {
        if (pattern.indexOf(regexStr[i]) != -1) {
            return false
        }
    }   

    return true
}

export const validateAlphabetic = (value) => {
    var alphabet = 'abcdefghijklmnopqrstuvwxyz'
    for(var i = 0; i <= value.length - 3; i++) {
        var substring = value[i]+value[i+1]+value[i+2]
        if(alphabet.includes(substring)){
            return false
        }
    }

    return true
}

export const validateCep = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        // value = value.replace('-', '')
        if (String(value).length === 9) {
            callback()
        } else {
            callback('Por favor, digite um CEP válido')
        }
    }
})

export const validateAgencia = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        if (String(value).length >= 4) {
            callback()
        } else {
            callback('Esse campo deve conter pelo menos 4 caracteres')
        }
    }
})


export const validateNumeroBanco = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        if ((value).match(/\d{5}-?\d/)) {
            callback()
        } else {
            callback('Esse campo deve conter pelo menos 6 caracteres, incluindo o dígito.')
        }
    }
})

export const validateCaracteresUpload = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        const specialChars = /^[a-zA-Z-0-9_-\d ]+$/
        const fileWithoutExtension = value.file.name.split('.').slice(0,-1).join()
        if (specialChars.test(fileWithoutExtension)) {
            callback()
        } else {
            callback('O nome do arquivo não pode conter caracteres especiais e acentos.')
        }
    }
})

export const validateAcceptedFormat = () => ({
    validator: (_, value, callback) => {
        if (!value) return callback()
        const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
        if (acceptedFormats.includes(value.file.name.split('.')[1]) === true) {
            callback()
        } else {
            callback('Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.')
        }
    }
})

export const validateFileSize = () => ({
    validator: (_, value, callback) => {
        if(!value) return callback()
        if (typeof (value.file) != "undefined") {
            const fileSize = value.file.size
            if (fileSize < 5242880) { // 5MB in bytes
                callback()
            } else {
                callback('Por favor, envie arquivos de até 5MB.')
            }
        }
    }
})
